/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ValidateSubmitOrderOptions,
  ValidateSubmitOrderResponses,
} from '../types/ValidateSubmitOrder'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Validate submit order request data
 * {@link /v1/orders/validate}
 */
export function validateSubmitOrder<ThrowOnError extends boolean = true>(
  options: Options<ValidateSubmitOrderOptions, ThrowOnError>,
): Unwrappable<RequestResult<ValidateSubmitOrderResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/orders/validate',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ValidateSubmitOrderResponses, ThrowOnError>>,
  )
}
